// NB: Some tasks should not upscale in young audiences, and as such we
// force them to be rendered in the 'default' 18px mode.
function getAudienceForTask(task, desiredLayout) {
  switch (task.taskType) {
    case "Group":
      return "default";
    case "Match":
      return "default";

    // @ts-expect-error We explictly want to fallthrough to our default
    // case if nothing matches fully.
    case "SelectAnswers":
      {
        switch (task.answerType) {
          case "HyphenateWords":
            return "default";
        }
      }

    // @ts-expect-error We explictly want to fallthrough to our
    // default case if nothing matches fully.
    // eslint-disable-next-line no-fallthrough
    case "PlaceItems":
      {
        switch (task.answerType) {
          case "SolidItemsOnImage":
            return "default";
        }
      }

    // eslint-disable-next-line no-fallthrough
    default:
      return desiredLayout ?? "default";
  }
}

export { getAudienceForTask };
//# sourceMappingURL=get-audience-for-task.js.map
